var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 16.3333H19.2617M3.5 5.83333V22.1667C3.5 23.4553 4.54467 24.5 5.83333 24.5H22.1667C23.4553 24.5 24.5 23.4553 24.5 22.1667V10.5C24.5 9.21134 23.4553 8.16667 22.1667 8.16667L5.83333 8.16667C4.54467 8.16667 3.5 7.122 3.5 5.83333ZM3.5 5.83333C3.5 4.54467 4.54467 3.5 5.83333 3.5H19.8333M19.8333 16.3333C19.8333 16.6555 19.5722 16.9167 19.25 16.9167C18.9278 16.9167 18.6667 16.6555 18.6667 16.3333C18.6667 16.0112 18.9278 15.75 19.25 15.75C19.5722 15.75 19.8333 16.0112 19.8333 16.3333Z",
    stroke: "#20343E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet_icon.e3a4ed1d2c299b8e6e4d2ffd9158e9ed.svg";
export { ForwardRef as ReactComponent };